import axios from "../../../apis/Api";
import history, { logout } from "../../../history";
import { GET_SCR_REPORT } from "../../../Types";
import { toast } from "react-toastify";
import { showLoading, hideLoading } from "react-redux-loading-bar";
import * as XLSX from "xlsx";
import fileSaver from "file-saver";
import { getCustomCloumns } from "../../../utilities/FUNCTIONS";

export const getSCRReport = (postedData) => async (dispatch) => {
  dispatch(showLoading());
  await axios
    .post(`api/SCRReports/GetSCRReport`, postedData)
    .then(({ data }) => {
      dispatch({
        type: GET_SCR_REPORT,
        payload: data.response,
      });
      dispatch(hideLoading());
    })
    .catch(function (error) {
      dispatch(hideLoading());
      if (error.response) {
        if (error.response.status === 401) {
          logout();
          history.push("/login");
          history.go("/login");
        } else if (
          error.response.status === 400 &&
          error.response.data.errors
        ) {
          let errorMessage = "";
          var errors = error.response.data.errors;
          var keys = Object.keys(errors);
          for (let j = 0; j < keys.length; j++) {
            errorMessage += errors[keys[j]] + " , \n";
          }
          toast.error(errorMessage);
        } else if (error.response.data)
          toast.error(
            error.response.data.Message
              ? error.response.data.Message
              : error.response.data.message,
          );
        else {
          toast.error("Error while processing the request");
        }
      } else toast.error("Error while processing the request");
    });
};

export const exportReport = (requestData) => async (dispatch) => {
  dispatch(showLoading());
  await axios
    .post(`api/SCRReports/ExportSCRReport`, requestData)
    .then(({ data }) => {
      const outputFilename = `ScrReport${Date.now()}`;
      const fileType =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      const fileExtension = ".xlsx";

      const getCustomColumns = (csvData, selectedColumns) => {
        return csvData.map((row) => {
          let filteredRow = {};
          selectedColumns.forEach((column) => {
            if (row.hasOwnProperty(column)) {
              filteredRow[column] = row[column];
            }
          });
          return filteredRow;
        });
      };

      const exportToCSV = (csvData, fileName) => {
        csvData = getCustomColumns(csvData, [
          "shopOrderId",
          "distCenter",
          "vizShopCode",
          "deliverymanName",
          "deliverymanTillNo",
          "distShopCode",
          "shopName",
          "invoiceNo",
          "invoiceDate",
          "originalNetSales",
          "rtgCollection",
          "marketReturnCollection",
          "additionalSaleCollection",
          "withHoldingTaxCollection",
          "invoiceAmount",
          "skInvoiceAmount",
          "totalJazzcashViaVizlink",
          "totalEasyPaisaViaVizlink",
          "totalAikPaymentViaVizlink",
          "totalAikPaymentQRViaVizlink",
          "totalOneBillViaVizlink",
          "totalLoanCollection",
          "totalMBLCollection",
          "totalCoinsCollection",
          "totalVizlinkDigitalCollection",
          "totalJazzcashOutSideVizlink",
          "totalEasyPaisaOutSideVizlink",
          "totalOutSideVizlinkDigitalCollection",
          "totalDigitalCollection",
          "totalCashCollection",
          "totalChequeCollection",
          "totalCreditCollection",
          "totalIBFTBankCollection",
          "nonVizlinkPaymentsCollection",
          "totalCollection",
          "totalDigitalCollectionOnTotal",
          "totalDigitalVizlinkCollectionOnTotal",
          "totalDigitalVizlinkCollectionOnTotalDigital",
        ]);
        const ws = XLSX.utils.json_to_sheet(csvData);
        if (ws) {
          var range = XLSX.utils.decode_range(ws["!ref"]);
          for (var C = range.s.c; C <= range.e.c; ++C) {
            var address = XLSX.utils.encode_col(C) + "1"; // <-- first row, column number C
            if (!ws[address]) continue;
            ws[address].v =
              ws[address].v == "distCenter"
                ? "Dist Center"
                : ws[address].v == "vizShopCode"
                  ? "Viz ID"
                  : ws[address].v == "deliverymanName"
                    ? "Deliveryman Name"
                    : ws[address].v == "deliverymanTillNo"
                      ? "DLM Till No."
                      : ws[address].v == "distShopCode"
                        ? "Shop Code"
                        : ws[address].v == "shopName"
                          ? "Shop Name"
                          : ws[address].v == "invoiceNo"
                            ? "Invoice No."
                            : ws[address].v == "invoiceDate"
                              ? "Inv Date"
                              : ws[address].v == "originalNetSales"
                                ? "Original Invoice Value"
                                : ws[address].v == "rtgCollection"
                                  ? "RTG"
                                  : ws[address].v == "marketReturnCollection"
                                    ? "Market Return"
                                    : ws[address].v ==
                                        "additionalSaleCollection"
                                      ? "Additional Sale"
                                      : ws[address].v ==
                                          "withHoldingTaxCollection"
                                        ? "With Holding Tax"
                                        : ws[address].v == "invoiceAmount"
                                          ? "Updated Invoice Amount"
                                          : ws[address].v == "skInvoiceAmount"
                                            ? "SK Updated Invoice Amount"
                                            : ws[address].v ==
                                                "totalJazzcashViaVizlink"
                                              ? "Jazz Cash through Vizlink"
                                              : ws[address].v ==
                                                  "totalEasyPaisaViaVizlink"
                                                ? "Easypaisa through Vizlink"
                                                : ws[address].v ==
                                                    "totalAikPaymentViaVizlink"
                                                  ? "Aik through Vizlink"
                                                  : ws[address].v ==
                                                      "totalAikPaymentQRViaVizlink"
                                                    ? "Raast QR through Vizlink"
                                                    : ws[address].v ==
                                                        "totalOneBillViaVizlink"
                                                      ? "1Bill Payment"
                                                      : ws[address].v ==
                                                          "totalCreditBookCollection"
                                                        ? "Lending through CreditBook"
                                                        : ws[address].v ==
                                                            "totalBAFLCollection"
                                                          ? "Lending Through Bank Alfalah"
                                                          : ws[address].v ==
                                                              "totalMBLCollection"
                                                            ? "Lending Through Meezan Bank Limited"
                                                            : ws[address].v ==
                                                                "totalCoinsCollection"
                                                              ? "Coins through Vizlink"
                                                              : ws[address].v ==
                                                                  "totalVizlinkDigitalCollection"
                                                                ? "Total Digital Transfer through Vizlink"
                                                                : ws[address]
                                                                      .v ==
                                                                    "totalJazzcashOutSideVizlink"
                                                                  ? "Jazz Cash other than Vizlink"
                                                                  : ws[address]
                                                                        .v ==
                                                                      "totalEasyPaisaOutSideVizlink"
                                                                    ? "Easypaisa other than Vizlink"
                                                                    : ws[
                                                                          address
                                                                        ].v ==
                                                                        "totalOutSideVizlinkDigitalCollection"
                                                                      ? "Total Digital Transfer other than Vizlink"
                                                                      : ws[
                                                                            address
                                                                          ].v ==
                                                                          "totalDigitalCollection"
                                                                        ? "Total Digital Transfer"
                                                                        : ws[
                                                                              address
                                                                            ]
                                                                              .v ==
                                                                            "totalCashCollection"
                                                                          ? "Cash"
                                                                          : ws[
                                                                                address
                                                                              ]
                                                                                .v ==
                                                                              "totalChequeCollection"
                                                                            ? "Cheque Sales"
                                                                            : ws[
                                                                                  address
                                                                                ]
                                                                                  .v ==
                                                                                "totalCreditCollection"
                                                                              ? "Clean Credit Sales"
                                                                              : ws[
                                                                                    address
                                                                                  ]
                                                                                    .v ==
                                                                                  "totalIBFTBankCollection"
                                                                                ? "IBFT Bank to Bank Digital"
                                                                                : ws[
                                                                                      address
                                                                                    ]
                                                                                      .v ==
                                                                                    "nonVizlinkPaymentsCollection"
                                                                                  ? "Non Vizlink Payments"
                                                                                  : ws[
                                                                                        address
                                                                                      ]
                                                                                        .v ==
                                                                                      "totalCollection"
                                                                                    ? "Total Collection"
                                                                                    : ws[
                                                                                          address
                                                                                        ]
                                                                                          .v ==
                                                                                        "totalDigitalCollectionOnTotal"
                                                                                      ? "% of Total Digital Transfer on Total Collection"
                                                                                      : ws[
                                                                                            address
                                                                                          ]
                                                                                            .v ==
                                                                                          "totalDigitalVizlinkCollectionOnTotal"
                                                                                        ? "% of Total Vizlink Collection on Total Collection"
                                                                                        : ws[
                                                                                              address
                                                                                            ]
                                                                                              .v ==
                                                                                            "totalDigitalVizlinkCollectionOnTotalDigital"
                                                                                          ? "% of Total Vizlink Collection on Total Digital Collection"
                                                                                          : ws[
                                                                                              address
                                                                                            ]
                                                                                              .v;
          }
        }
        const wb = {
          Sheets: { data: ws },
          SheetNames: [`data`],
        };
        const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
        const fileData = new Blob([excelBuffer], { type: fileType });
        fileSaver.saveAs(fileData, fileName + fileExtension);
      };

      exportToCSV(data.response?.data, outputFilename);
      dispatch(hideLoading());
    })

    .catch(function (error) {
      dispatch(hideLoading());
      if (error.response) {
        if (error.response.status === 401) {
          logout();
          history.push("/login");
          history.go("/login");
        } else if (error.response.data)
          toast.error(
            error.response.data.Message
              ? error.response.data.Message
              : error.response.data.message,
          );
        else {
          toast.error("Error while processing the request");
        }
      }
    });
};
